import axiosConfig from './axiosConfig';

/**
 * Get list of all vendors
 * @param {Object} queryParams Optional query parameters
 * @returns {Promise} Response with list of vendors
 */
export const getVendors = async (queryParams = {}) => {
    try {
        const response = await axiosConfig.get('vendors', { params: queryParams });
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Create a new vendor
 * @param {Object} vendorData Vendor data to create
 * @returns {Promise} Response with created vendor data
 */
export const createVendor = async (vendorData) => {
    try {
        const response = await axiosConfig.post('vendors', vendorData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (error) {
        throw error || 'Failed to create vendor';
    }
};

/**
 * Get a vendor by ID (with related spareparts)
 * @param {string|number} vendorId Vendor ID
 * @returns {Promise} Response with vendor and related spareparts
 */
export const getVendorById = async (vendorId) => {
    try {
        const response = await axiosConfig.get(`vendors/${vendorId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * Update a vendor by ID (PUT)
 * @param {string|number} vendorId Vendor ID
 * @param {Object} vendorData Vendor data to update
 * @returns {Promise} Response with updated vendor data
 */
export const updateVendor = async (vendorId, vendorData) => {
    try {
        const response = await axiosConfig.put(`vendors/${vendorId}`, vendorData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (error) {
        throw error || 'Failed to update vendor';
    }
};

/**
 * Partially update a vendor by ID (PATCH)
 * @param {string|number} vendorId Vendor ID
 * @param {Object} vendorData Vendor data to update
 * @returns {Promise} Response with updated vendor data
 */
export const patchVendor = async (vendorId, vendorData) => {
    try {
        const response = await axiosConfig.patch(`vendors/${vendorId}`, vendorData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (error) {
        throw error || 'Failed to update vendor';
    }
};

/**
 * Delete a vendor by ID (soft delete)
 * @param {string|number} vendorId Vendor ID
 * @returns {Promise} Response from delete operation
 */
export const deleteVendor = async (vendorId) => {
    try {
        const response = await axiosConfig.delete(`vendors/${vendorId}`);
        return response;
    } catch (error) {
        throw error || 'Failed to delete vendor';
    }
};

/**
 * Get vendor categories
 * @returns {Promise} Response with vendor categories
 */
export const getVendorCategories = async () => {
    try {
        const response = await axiosConfig.get('vendors/categories');
        return response;
    } catch (error) {
        throw error;
    }
};